import biliShare from '@bilibili/share-h5-next';
import '@bilibili/share-h5-next/dist/share-h5.css';

import '@bilibili/share-h5-next/dist/share-h5.css';
import { initEnv, inBiliApp, biliBridge, isSupport } from '@bilibili/js-bridge'
import toast from '@bilibili/vanilla-toast';

export const sharePanel = (dataUrl: any) => {
  const options = {
    title: '你的愚人节防骗卡是？', // 分享标题
    desc: '我在《哔哩日报》拿到了这张防骗卡！你领到了吗？戳链接去看看>>', // 分享描述
    link: location.href, // 分享链接，必传，请传一个可以访问的url
    // pics: 'https://i0.hdslb.com/bfs/activity-plat/static/20200619/b8f2b74d0482aed61472c7065dc1ed56/LjvZEBwmnu.png', 
    pictureList: [{
      img_height: 100,
      img_size: 100,
      img_src: dataUrl,
      img_width: 100,
    }],
    edit_content: `我在《哔哩日报》拿到了这张防骗卡！你领到了吗？戳链接去看看>> ${'https://www.bilibili.com/blackboard/activity-HW2u5b44Dm.html?msource_dynamic'}`, // 动态预设文案
    // 分享带话题（非必填）
    share_from_topic_name: '你的愚人节防骗卡是？', // >=6.51版本支持，动态分享话题名称
    share_from_topic_id: 1172477, // >=6.51版本支持，动态分享话题id 
  };

  // 希望显示分享面板时调用 showWindow
  biliShare.showWindowTypeImage(options);
};

export async function saveImageToPhotosAlbum(dataUrl: string, name: string, callback?: (info: string) => void) {
  if (!dataUrl) return;
  if (!inBiliApp) return toast.info('请在哔哩哔哩App中打开～')
  const isBase64 = dataUrl.startsWith('data');
  const curMessage = name ==='poster'?'海报保存成功，请到系统相册查看':'保存成功，请到系统相册查看'
  return isSupport('ability.saveImageToPhotosAlbum').then(
      (support: boolean) => {
        if (support) {
          return new Promise(resolve => {
            biliBridge.callNative({
              method: 'ability.saveImageToPhotosAlbum',
              data: {
                filePath: isBase64 ? undefined : dataUrl, // 图片文件路径，仅支持网络图片路径，filePath与base64Data必填其一
                base64Data: isBase64 ? dataUrl : undefined, // ase64字符串，上限2M，filePath与base64Data必填其一，eg: data:image/png;base64,R0lGODdhMAAwAPAAAAAAAP
              },
              // @ts-expect-error
              callback: (info: { code: number; errMsg: string }) => {
                let message;
                if (info && typeof info.code !== 'undefined') {
                  const code = +info.code;
                  switch (code) {
                    case 0:
                      message = curMessage;
                      break;
                    case -1:
                      message = '抱歉，发生未知错误，请重试'
                      break
                    case -2:
                      message = '抱歉，相册授权失败，请开启权限后再试';
                      break;
                    case -3:
                      message = '抱歉，文件读取失败！';
                      break;
                    case -4:
                      message = '抱歉，壁纸保存失败，请重试'
                      break
                    case -5:
                      message = '壁纸已经保存到相册咯，快去看看吧！';
                      break;
                    default:
                      message = info.errMsg;
                  }
                  callback && callback(message);
                  resolve(message);
                }
              },
            });
          });
        }
      },
  );
}